import React, { useState } from "react";
import { Dropdown, Button, Form } from "react-bootstrap";
import SelectableContext from "react-bootstrap/SelectableContext";
import { getWeightText, productPackagingInCart } from "../../helper";
import { TiDelete } from "react-icons/ti";
import { FaCheck } from "react-icons/fa";

export default function WeightOrDropDown(props) {
  const {
    product,
    productPackaging,
    setSelectedWeight,
    selectedWeight,
    search,
    productQuantity,
  } = props;
  const [showCustomPackaging, setShowCustomPackaging] = useState(false);
  const packaging = productPackagingInCart(productQuantity);
  const [customPackaging, setPackaging] = useState(selectedWeight);
  return (
    <>
      <SelectableContext.Provider value={false}>
        <Dropdown
          onClick={(event) => {
            if (!search) {
              event.preventDefault();
              event.stopPropagation();
            }
          }}
          className="my-auto justify-content-center"
          style={{ width: "75%" }}
        >
          <Dropdown.Toggle className="w-100 p-0">
            {selectedWeight ? getWeightText(selectedWeight) : "Custom"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            {productPackaging.map((element) => (
              <Dropdown.Item
                disabled={
                  selectedWeight !== element && packaging.includes(element)
                }
                key={product.product_id + "-" + element}
                eventKey={product.product_id + "-" + element}
                onClick={async (event) => {
                  !search && event.stopPropagation();
                  setSelectedWeight(element);
                }}
                id={product.product_id}
                active={selectedWeight === element}
              >
                {getWeightText(element)}
              </Dropdown.Item>
            ))}
            <hr />
            <>
              {!showCustomPackaging ? (
                <div className="d-flex justify-content-center">
                  <Button
                    className="landing-button h-50 w-75"
                    variant="outline-warning"
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setShowCustomPackaging(true);
                    }}
                  >
                    Custom
                  </Button>
                </div>
              ) : (
                <>
                  <Form.Text className="text-muted text-center">
                    Custom Packaging in GMS
                  </Form.Text>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      className="h-100"
                      type="number"
                      pattern="\d*"
                      value={customPackaging}
                      style={{ width: "60%" }}
                      onChange={(event) => {
                        setPackaging(Number(event.target.value));
                      }}
                    />
                    <FaCheck
                      size={35}
                      className="ml-2 mr-1"
                      onClick={() => setSelectedWeight(customPackaging)}
                    />
                    <TiDelete
                      className="align-self-center ml-1 mr-1"
                      size={45}
                      onClick={() => setShowCustomPackaging(false)}
                    />
                  </div>
                </>
              )}
            </>
          </Dropdown.Menu>
          <Form.Text className="text-muted text-center">Packing Size</Form.Text>
        </Dropdown>
      </SelectableContext.Provider>
    </>
  );
}
